module.exports = __webpack_public_path__ + "static/media/logo.fd1d9bd1.svg";